export default __webpack_public_path__ + "static/media/sling-swing2.23186d49.ogg";